import { Navigate, Outlet, useLocation } from "react-router-dom";
import useUserInformation from "../../hooks/useUserInformation";

function Authentication() {
  const location = useLocation();
  const { isAuth } = useUserInformation();

  if (
    !isAuth &&
    location.pathname !== "/login" &&
    location.pathname.includes("/tokenLogin/") === false
  ) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}

export default Authentication;
